import styled from '@emotion/styled';
import { helperTypographyText, helperLinkReset, media, Colors, ButtonEmotion } from '@utex/ui-kit';
import { css } from '@emotion/react';

export interface ColorProps {
  isWhite?: boolean;
}

export const Line = styled('a')`
  ${helperLinkReset};
  position: relative;
  margin-bottom: 1.4rem;
  transition-property: opacity;
  opacity: 0.5;

  &:hover,
  &:focus {
    opacity: 1;
  }

  &:focus {
    outline: 0;
  }
`;

export const FooterWrapper = styled('footer')<ColorProps>`
  display: flex;
  margin-top: 10rem;
  padding-top: 2rem;
  border-top: 1px solid
    ${props => (props.isWhite ? 'rgba(255, 255, 255, 0.1)' : Colors.ut.border10)};
  color: ${props => (props.isWhite ? Colors.text.inverse : Colors.text.default)};

  ${Line} {
    &:hover,
    &:focus {
      color: ${props => (props.isWhite ? Colors.text.inverse : Colors.text.default)};
    }
  }

  @media ${media.phonablet} {
    flex-direction: column;
  }
`;

export const Wrapper = styled('div')`
  flex-shrink: 0;
  display: flex;
  margin-bottom: 2.8rem;

  &:last-of-type {
    flex-grow: 1;
  }
`;

export const Col = styled('div')`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  margin-right: 5rem;

  &:only-child {
    margin-right: 0;
  }

  @media ${media.tablet} {
    margin-right: 3rem;
  }

  @media ${media.phonablet} {
    min-width: calc(100% / 2);
    margin: 0;
  }
`;

export const Title = styled('h5')<ColorProps>`
  ${helperTypographyText({
    size: 'small',
    lh: 'big',
    weight: 'bold',
    caps: true
  })};
  margin-bottom: 1.2rem;
  letter-spacing: 1px;
`;

export const socialIcon = css`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto 0;
`;

export const AppButton = styled('div')`
  display: flex;

  @media ${media.tablesktop} {
    flex-direction: column;
  }

  ${ButtonEmotion} {
    padding-left: 1.4rem;
    padding-right: 1.4rem;

    @media (min-width: 375px) and ${media.phonablet} {
      padding-left: 2rem;
      padding-right: 2rem;
    }
  }

  ${ButtonEmotion} + ${ButtonEmotion} {
    margin-top: 0.5rem;

    @media ${media.phonablet} {
      margin-top: 0;
      margin-left: 2rem;
    }
  }
`;

export const ButtonText = styled('span')`
  flex-grow: 1;
  margin-left: 0.7rem;
  text-align: left;
  font-size: 1.3rem;
  line-height: 1.23;

  @media ${media.phonablet} {
    line-height: 1.38;
  }
`;
